package gr.tech.GRAttestation.styles.grstyles

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.minWidth
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span

val defaultPlaceholderStyle = CssStyle {
    base {
        Modifier
            .minWidth(75.px)
    }
}

// While technically a composable function, because it has to be,
// I still consider this a style
@Composable
fun BPlaceholder(modifier: Modifier = Modifier) {
    P(Modifier.fillMaxWidth().classNames("placeholder-glow").toAttrs()) {
        Span(defaultPlaceholderStyle.toModifier().classNames("placeholder").then(modifier).toAttrs {  })
    }
}